import React from 'react';
import StreamingLayout from '@alphapoint/apex-web/lib/layouts/StreamingLayouts/StreamingLayout';
import StreamingGridContainer from '../components/Streaming/StreamingGridContainer';
import RecentActivityWithFilterContainer from '@alphapoint/apex-web/lib/components/RecentActivityWithFilter';
import BalancesListLayout from '@alphapoint/apex-web/lib/layouts/BalancesListLayout/BalancesListLayout';
import PageFooterLayout from '../layouts/PageFooterLayout/PageFooterLayout';

const StreamingPage = () => (
  <StreamingLayout
    component1={<StreamingGridContainer />}
    component2={<BalancesListLayout />}
    component3={<RecentActivityWithFilterContainer filterForSelected={false} pageSize={10} minRow={10} />}
    footer={<PageFooterLayout />}
  />
);

export default StreamingPage;
